import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to the top of the page whenever the route changes.
// Uses `instant` behaviour so navigation feels immediate; anchor links (#hash)
// keep their native jump-to behaviour.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}
